import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';
import { FontIconComponent } from '@camelot/icons';
import { ExpandableTextComponent } from '@camelot/ui';

import { BillingRow } from '../../../../../common/services/dto/row';

@Component({
  host: { 'data-cid': 'grid-full-width-cell-comment' },
  imports: [ExpandableTextComponent, FontIconComponent],
  selector: '',
  styleUrl: './full-width.component.scss',
  templateUrl: './full-width.component.html',
})
export class GridFullWidthCellCommentComponent extends AbstractCellComponent<BillingRow, string> {}
